<template>
    <v-row>
        <v-col cols="12" md="6">
            <span v-if="order.product.deleted" class="title grey--text darken-3">
                {{ $t('productDeleted') }}
            </span>
            <a v-else :href="fullUrl" class="title grey--text darken-3" target="_blank">
                {{ order.product.name }}
            </a>
        </v-col>
        <v-col cols="12" offset-md="3" md="3" class="py-4 py-md-0">
            <v-autocomplete
                v-model="data.status"
                :label="$t('status')"
                :items="statuses"
                item-text="name"
                item-value="id"
                color="teal lighten-2"
            ></v-autocomplete>
        </v-col>
    </v-row>
</template>

<script>
    import { MixinOrderInfo } from '../../../mixins';
    import { InfoService } from '../../../services';

    export default {
        name: 'StatusInfo',
        mixins: [MixinOrderInfo],
        data() {
            return {
                statuses: [],
                key: 'statusInfo',
            }
        },
        computed: {
            fullUrl() {
                return this.$store.getters.frontUrl + this.order.product.fullUrl;
            }
        },
        methods: {
            getStatuses() {
                InfoService.setLocale(this.$store.getters.appLanguage);
                InfoService.getOrderStatuses()
                    .then(res => {
                        this.statuses = res.data;
                    })
                    .catch(console.log);
            },
            orderHandle(value) {
                const { status } = value;
                this.data = {
                    status: status.id,
                }
            },
        },
        created() {
            this.getStatuses();
        },
    }
</script>

<style scoped>

</style>
